import { MaterialGridInput } from 'models/order-input/shared';

export const emptyMaterialInput = () => {
    return {
        materialCode: '',
        description: '',
        quantity: '',
        batchNumber: '',
        unitPrice: '',
        vatPercent: '',
        priceWithoutVat: 0,
        priceWithVat: 0,
        isValid: true,
        isActionMaterial: false,
    } as MaterialGridInput;
};

export const isMaterialRowEmpty = (material: MaterialGridInput) => {
    return Object.values(material).every(
        (v) => v === '' || v === null || v === undefined || v === true || v === false || v === 0,
    );
};
